import * as React from "react";
const VisitPassive = () => (
	<svg width="15" height="15" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.77766 0.769531L1.56055 5.23238" stroke="white" stroke-linecap="square" stroke-linejoin="round" />
		<path d="M1.56219 0.769531L5.7793 5.23238" stroke="white" stroke-linecap="square" stroke-linejoin="round" />
	</svg>

);
export default VisitPassive;
